import { STORAGE_KEYS } from '@repo/constants';
import { useCallback, useMemo } from 'react';
import { useLocalStorage } from './use-local-storage';
export function useExpandedProjects(selectedOrg) {
    const storageKey = selectedOrg ? "".concat(STORAGE_KEYS.EXPANDED_PROJECTS, ":").concat(selectedOrg) : '';
    const [savedExpandedProjects, setSavedExpandedProjects] = useLocalStorage(storageKey, []);
    const expandedProjects = useMemo(()=>new Set(savedExpandedProjects), [
        savedExpandedProjects
    ]);
    const setExpandedProjects = useCallback((projects)=>{
        if (!selectedOrg) {
            return;
        }
        setSavedExpandedProjects(projects);
    }, [
        selectedOrg,
        setSavedExpandedProjects
    ]);
    const toggleProject = useCallback((projectId)=>{
        const currentArray = Array.from(expandedProjects);
        const newArray = expandedProjects.has(projectId) ? currentArray.filter((id)=>id !== projectId) : [
            ...currentArray,
            projectId
        ];
        setExpandedProjects(newArray);
    }, [
        expandedProjects,
        setExpandedProjects
    ]);
    const expandProject = useCallback((projectId)=>{
        const currentArray = Array.from(expandedProjects);
        if (!expandedProjects.has(projectId)) {
            setExpandedProjects([
                ...currentArray,
                projectId
            ]);
        }
    }, [
        expandedProjects,
        setExpandedProjects
    ]);
    const expandAll = useCallback((allProjectIds)=>{
        setExpandedProjects(allProjectIds);
    }, [
        setExpandedProjects
    ]);
    const collapseAll = useCallback(()=>{
        setExpandedProjects([]);
    }, [
        setExpandedProjects
    ]);
    return {
        expandedProjects,
        toggleProject,
        expandProject,
        expandAll,
        collapseAll
    };
}
